import { requestAndParse, requestSuccessful } from '../request';

const getAnonymizedDeviceUsers = async () => {
    const route = 'admin/get-anonymized-device-users';

    const response = await requestAndParse(route, {}, 'GET');

    const success = requestSuccessful(response);
    const ids = (response.body?.ids ?? []) as string[];

    return { success, ids };
};

export default getAnonymizedDeviceUsers;
